<template>
  <div v-if="user">
    <VerticalNavbar>
      <div class="content">
        <router-view/>
      </div>
    </VerticalNavbar>
  </div>
  <div v-else>
    <LandingPageNavbar/>
    <div class="content">
      <router-view/>
    </div>
  </div>
</template>

<script setup>
import getUser from '@/composables/getUser';
import LandingPageNavbar from './components/LandingPageNavbar.vue';
import VerticalNavbar from './components/VerticalNavbar.vue';
const { user } = getUser();
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
